import React, { useMemo, useState } from "react";
import Button from "../Button";
import Text from "../Text";
import { COLOR_SYSTEM } from "../../design/design-system";
import {
  InputField,
  InputWrapper,
  Wrapper,
} from "components/atoms/SearchBar/style";
import Icon from "../Icon";

export interface SearchBarProps {
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string | React.ReactNode;
  value?: string;
  className?: string;
  style?: React.CSSProperties;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onClear?: (params?: any) => any;
  onClick?: (params?: any) => any;
  onFocus?: (params?: any) => any;
  onBlur?: (params?: any) => any;
}

const SearchBar = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  SearchBarProps
>(
  (
    {
      type = "text",
      placeholder,
      value,
      className,
      style,
      onChange,
      onKeyDown,
      onClear = () => {},
      onClick,
      onFocus = () => {},
      onBlur = () => {},
    },
    ref
  ) => {
    const [focus, setFocus] = useState(false);

    return (
      <Wrapper className={className} style={style}>
        <InputWrapper onClick={onClick}>
          <Icon
            name={"Search"}
            color={COLOR_SYSTEM.get("Gray")[300]}
            size={20}
          />
          <InputField
            ref={ref as React.ForwardedRef<HTMLInputElement>}
            type={type}
            autoComplete="off"
            spellCheck="false"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={() => {
              setFocus(true);
              onFocus();
            }}
            onBlur={() => {
              setFocus(false);
              onBlur();
            }}
          />

          {focus && value && (
            <Button
              color="Quaternary"
              icon="X"
              size="Medium"
              type="Icon"
              variant="Ghost"
              onClick={(e) => {
                onClear();
              }}
            />
          )}
        </InputWrapper>
      </Wrapper>
    );
  }
);

export default SearchBar;
